import { render, staticRenderFns } from "./modal-task-header.vue?vue&type=template&id=158006e6&scoped=true&"
import script from "./modal-task-header.vue?vue&type=script&lang=ts&"
export * from "./modal-task-header.vue?vue&type=script&lang=ts&"
import style0 from "./modal-task-header.vue?vue&type=style&index=0&id=158006e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158006e6",
  null
  
)

export default component.exports